/**
 * Instance Monitoring Tab Component
 *
 * Placeholder for CPU/Memory monitoring charts.
 * Will integrate with monitoring API in future phase.
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Activity } from 'lucide-react'

const InstanceMonitoring = () => {
    return (
        <Card className="mt-2">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Activity className="h-5 w-5" />
                    Monitoring
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="text-center py-12 text-muted-foreground">
                    <Activity className="h-12 w-12 mx-auto mb-4 opacity-50" />
                    <p className="text-lg font-medium">
                        Monitoring Coming Soon
                    </p>
                    <p className="text-sm mt-2">
                        CPU, Memory, and Network usage charts will be available
                        in a future update.
                    </p>
                </div>
            </CardContent>
        </Card>
    )
}

export default InstanceMonitoring
